<h4>References</h4>

@if (details(); as details) {
  @if (details.clientOrderNumber) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.client-order-number' | translate"
      [data]="details.clientOrderNumber"
    ></myarvato-data-field>
  }

  @if (details.customerReference) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.customer-reference' | translate"
      [data]="details.customerReference"
    ></myarvato-data-field>
  }

  @if (details.customerReference1) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.customer-reference-2' | translate"
      [data]="details.customerReference1"
    ></myarvato-data-field>
  }

  @if (details.customerReference2) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.customer-reference-3' | translate"
      [data]="details.customerReference2"
    ></myarvato-data-field>
  }

  @if (details.arvatoDeliveryNumber) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.arvato-delivery-number' | translate"
      [data]="details.arvatoDeliveryNumber"
    ></myarvato-data-field>
  }

  @if (details.deliveryNoteNumber) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.delivery-note-number' | translate"
      [data]="details.deliveryNoteNumber"
    ></myarvato-data-field>
  }

  @if (details.shipmentNumber) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.shipment-number' | translate"
      [data]="details.shipmentNumber"
    ></myarvato-data-field>
  }

  @if (details.bulkMasterNumber) {
    <myarvato-data-field
      styleClass="pb--8"
      [label]="'pages.transport.detail-page.references.bulk-master-number' | translate"
      [data]="details.bulkMasterNumber"
    ></myarvato-data-field>
  }
}
